import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-customer-page-state',
  templateUrl: './customer-page-state.component.html',
  styleUrls: ['./customer-page-state.component.sass']
})
export class CustomerPageStateComponent implements OnInit {

  @Input() customerId: string;

  public columns: Array<any> = [
    {
      title: 'Component Name',
      name: 'Name',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by name'
      },
      width: '325px'
    },
    {
      title: 'Version',
      name: 'Version',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by version'
      }
    },
    {
      title: 'Details',
      name: 'Details',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by details'
      },
      width: '325px'
    },
    {
      title: 'Error Description',
      name: 'ErrDesc',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by error'
      },
      width: '325px'
    }
  ];

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    className: ['table-striped', 'table-bordered'],
    filtering: { filterString: '' }
  };

  public latestUpdate: any = {};
  public components: Array<any> = [];

  constructor(
    private api: ApiService
  ) { }

  ngOnInit(): void {
    this.api.get(`customers/${this.customerId}/currentstate`,
      (result: any) => {
        this.latestUpdate = result.LatestStatus;
        this.components = result.Components;
    });
  }

}
